<div class="flex items-center justify-center w-screen h-screen bg-surface-container-lowest">
<ng-container *ngIf="theme$ | async as theme">
    <canvas riv="app_loading_{{ theme }}" width="72" height="72">
    <riv-player name="Timeline 1" play></riv-player>
    </canvas>
</ng-container>
</div>